var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"streetview"},[(!_vm.panorama)?_c('div',{staticClass:"instructions"},[_vm._v("\n        Seleccione una ubicacion en el mapa\n    ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }